<template>
    <l-dialog :title="$t('粘贴')" 
    :visible.sync="visible" @ok="save" @close="close" :hideCancelBtn="true"
    :width="800" :height="600" 
    :okBtnLabel="step == 1 ? $t('下一步') : $t('确定')" >
        <template #stepExtendBtns>
            <el-button size="mini" @click="step = 1" v-if="step !== 1">{{$t('上一步')}}</el-button>
        </template>
        <div class="dg-box" v-if="visible">
            <div v-show="step === 1" style="height: 100%;">
                <div class="tip-list">
                    <div class="tip-item">
                        使用快捷键<b> ctrl + v </b>将Excel内容直接粘贴至表格中，使用<b> ctrl + z </b>撤销粘贴操作，<b>双击单元格</b>进行编辑
                    </div>
                    <div class="tip-item">
                        已自动隐藏不支持粘贴的字段列，请注意对应字段顺序
                    </div>
                    <!-- <div class="tip-item">
                        当前子表单总行数<b>不可超过200行</b>
                    </div> -->
                </div>
                 <!-- :isShowNum="false" -->
                <l-table ref="table" :columns="newColumns" :cellClassName="cellClassName" @cellDblclick="cellDblclick" @cellClick="cellClick" :dataSource="list" style="height: 440px;" :border="true">

                </l-table>
            </div>
            <div v-show="step === 2" style="height: 100%;">
                <div class="tip-list">
                    <div class="tip-item" style="display: flex;align-items: center;justify-content: space-between;">
                        可在此页面核对数据，确认后会将此部分数据粘贴至「{{title || '子表'}}」中
                        <el-alert
                            style="width: auto;padding: 0 6px;"
                            :closable="false"
                            :title="`粘贴 ${pasteCol}列/共${newColumns.length}列`"
                            :type="pasteCol == newColumns.length ? 'success' : 'warning'"
                            show-icon>
                        </el-alert>
                    </div>
                </div>
                <l-table ref="table1" :highlightCurrentRow="false" :columns="newColumns"  :cellClassName="cellClassName1" :dataSource="addList" style="height: 496px;" :border="true">
                    <template v-for="i in newColumns" v-slot:[`${i.prop}_header`]="scope" >
                        <l-select :clearable="false" :key="i.prop" v-model="fieldTable[scope.property]" :options="fieldOptions" @change="handleHeadChange($event, scope)"></l-select>
                    </template>
                </l-table>
            </div>
            
        </div>
    </l-dialog>
</template>
<script>
export default {
  name: "pasteDg",
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    title: {
        default: ''
    },
    rowKey:[String,Function],
  },
  data() {
    return {        
        visible: false,
        step: 1,
        list: [],
        history: [],
        focus: false,
        active: {
            rowIndex: 0,
            colIndex: 'index0'
        },
        newColumns: [],
        fieldOptions: [],
        fieldTable: {}
    };
  },
  computed: {
    propKeys() {
        return this.newColumns.map(e => e.prop)
    },
    pasteCol () {
        return Object.values(this.fieldTable).filter(e => e != 'none').length
    },
    addList () {
        return this.list.filter(e => Object.values(e).some(e => e))
    }
  },       
  watch: {
    columns() {
        this.getNewColumns();
    }
  },
  beforeDestroy() {

    this.offEvent();

  },
  mounted() {
    this.getNewColumns();
  },
  methods: {
    handleHeadChange(item, row) {
        for (let key in this.fieldTable) {
            if (this.fieldTable[key] == item.value && row.property != key) {
                this.fieldTable[key] = 'none';
            }
        }
    },
    getNewColumns() {
        let arr = [], fieldOptions = [{
            label: '不粘贴',
            value: 'none'
        }], obj = {}
        function each(brr) {
            brr.forEach(col => {
                if (col.children && col.children.length > 0) {
                    each(col.children)
                }
                else if (!col.notPaste) { // 不支持粘贴的列不显示
                    obj[`index${arr.length}`] = col.prop
                    arr.push({
                        ...col,
                        prop: `index${arr.length}`,
                        width: col.label.length*12 + 68
                    })
                    
                    fieldOptions.push({
                        value: col.prop,
                        label: col.label
                    })
                }

            })
        }
        each(this.columns)
        this.newColumns = arr
        this.fieldOptions = fieldOptions
        this.fieldTable = obj
        this.$refs.table1 && this.$refs.table1.doLayout()
        console.log(this.fieldOptions, 'this.fieldOptions---')
        console.log(this.fieldTable, 'this.fieldTable---')
        console.log(this.newColumns, 'this.newColumns---')
    },
    cellClassName({row, column, rowIndex, columnIndex}) {
        if (rowIndex == this.active.rowIndex && column.property == this.active.colIndex) {
            return 'active-cell';
        }
    },
    cellClassName1({row, column, rowIndex, columnIndex}) {
        console.log(column, 'column--------')
        if (this.fieldTable[column.property] == 'none') {
            return 'disabled-cell'; 
        }
        // if (rowIndex == this.active.rowIndex && column.property == this.active.colIndex) {
        //     return 'active-cell';
        // }
    },
    show() {
        this.step = 1;
        this.initList();
        this.initEvent();
        this.visible = true;
        console.log(this.newColumns, 'this.newColumns')
    },
    handleUndo() {
        let list = this.history.pop();
        if (!list) {
            this.initList()
        } else {
            this.doLayout();
            this.list = this.$deepClone(list);
        }
        list = null
    },
    doLayout() {
        this.$nextTick(() => {
            this.$refs.table.doLayout();
        })
    },
    initList() {
        let list = [];
        for(let i = 0; i < 10; i++) {
            let obj = {}
            this.newColumns.forEach(col => {
                obj[col.prop] = "";
            })
            list.push(obj)
        }
        this.list = list;
        console.log(this.list, 'list')
    },
    getInitRow() {
        let obj = {}
        this.newColumns.forEach(col => {
            obj[col.prop] = "";
        })
        return obj
    },
    initEvent() {
        document.addEventListener('keydown', this.keyDownHandle);
        document.addEventListener('paste', this.handlePaste);
    },
    keyDownHandle(e) {
        if (this.focus || this.step !== 1) return
        if (e.ctrlKey && e.key === 'z') {
            this.handleUndo();
            e.preventDefault();
        }
    },
    handlePaste(e){
      if (this.focus || this.step !== 1) return
      const text = e.clipboardData.getData('text');
      if (!text) return;
          // 保存当前数据快照
      this.history.push(this.$deepClone(this.list));
      
      // 解析剪贴板数据（Tab分隔列，换行分隔行）
      const rows = text.split('\n').filter(row => row.trim());
      let startIndex = this.active.rowIndex, startColIndex = this.propKeys.indexOf(this.active.colIndex);
      // 如果粘贴位置不是最后一行，则删除后面的行
      rows.forEach((row, index) => {
        const cols = row.split('\t').map(item => item.trim());
        let obj = this.list[startIndex + index] || this.getInitRow();
        let colKeys = this.propKeys.slice(startColIndex, startColIndex + cols.length)

        colKeys.forEach((prop, idx) => {
            obj[prop] = cols[idx]
        })
        this.list.splice(startIndex + index, 1, obj)
      })
    },
    offEvent() {
        document.removeEventListener('keydown', this.keyDownHandle);
        document.removeEventListener('paste', this.handlePaste);
    },
    save() {
        if (this.step === 1) {
            if (!this.addList.length) {
                return this.$message.warning('请至少添加一行数据');
            }
            this.step = 2;
        }
        else {
            let list = [];
            this.addList.forEach(item => {
                let obj = {};
                let hasVal = false
                for (let key in this.fieldTable) {
                    if (this.fieldTable[key] != 'none') {
                        obj[this.fieldTable[key]] = item[key];
                        hasVal = true
                    }
                }
                if (this.rowKey && !obj[this.rowKey]) {
                    obj[this.rowKey] = this.$uuid();
                }
                hasVal && list.push(obj)
            })
            console.log(this.$deepClone(list), 'this.$deepClone(list)')
            this.$emit('save', this.$deepClone(list));
            list = null
            this.visible = false;
        }
    },
    close() {
        this.visible = false;
        this.history = [];
        this.active = {
            rowIndex: 0,
            colIndex: 'index0'
        }
        this.offEvent()
    },
    cellClick(row, column, cell, event) {
        console.log(row, column, cell, event)
        this.active = {
            rowIndex: this.list.indexOf(row),
            colIndex: column.property
        }
    },
    cellDblclick(row, column, cell, e) {
        e.target.contentEditable = true;
        this.$nextTick(() => {
            e.target.focus();
            this.focus = true;
            e.target.onblur = () => {
                e.target.contentEditable = false;
                if (row[column.property] != e.target.innerText) {
                    this.history.push(this.$deepClone(this.list));
                    row[column.property] = e.target.innerText;
                    e.target.innerText = row[column.property]
                }
                this.focus = false;
            }
        })
    }

  },        
};
</script>
<style scoped lang="less">
.dg-box {
    height: 100%;
    padding: 12px 16px;
}
.tip-list {
    margin-bottom: 12px;
    .tip-item {
        position: relative;
        padding-left: 20px;
        line-height: 24px;
        &::after {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 4px;
            background: #525967;
            border-radius: 50%;
        }
    }
}
::v-deep {
  .el-table td, .el-table th.is-leaf, .el-table--border .el-table__cell {
    border-right: 1px solid #E1E3E5;
  }
  .el-table--border, .el-table--group {
    border-left: 1px solid #E1E3E5 !important;
    border-top: 1px solid #E1E3E5 !important;
  }
  .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #E1E3E5 !important;
  }
  .cell {
    height: 34px !important;
    line-height: 34px;
  }
  .disabled-cell {
    background: #f5f6f8 !important;
  }
  .active-cell {
    .cell {
        outline: none;
        border: 2px solid #0D68FF;
        border-radius: 0;
        box-sizing: border-box !important;
        // width: calc(100% + 3px) !important;
        position: relative;
        line-height: 30px;
        // left: -1px;
        // top: -1px;
        z-index: 9;    }
  }
  .cell:focus { 
    outline: none;
  }


}
</style>